import { Box, Typography } from "@mui/material";
import React from "react";

interface TruncatedTextProps {
  text: string;
  subtext?: string | undefined | null;
  fontSize?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  showHoverEffect?: boolean;
  /** The rendered value element, so a caller can measure whether it is clipped. */
  ref?: React.Ref<HTMLDivElement>;
}

export const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  subtext,
  fontSize = "1rem",
  onClick,
  showHoverEffect = false,
  ref,
}) => {
  return (
    <Box
      ref={ref}
      onClick={onClick}
      sx={{
        fontSize,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        cursor: onClick ? "pointer" : "default",
        ...(showHoverEffect && {
          "&:hover": {
            textDecoration: "underline",
          },
        }),
      }}
    >
      {text}
      {subtext && (
        <Typography variant="caption" color="text.secondary" fontStyle={"italic"}>
          {" " + subtext}
        </Typography>
      )}
    </Box>
  );
};
